import * as React from 'react';
import PropTypes  from 'prop-types';

export default class FieldsetComponent extends React.Component {
	render() {
		const label      = this.props.label;
		const children   = this.props.children;
		const firstChild = children.length ? children[0] : children;

		return (
			<fieldset className="form-group">
				<div className="row">
					<legend className="col-form-legend col-sm-2">{this.props.label}</legend>
					<div className="col-sm-10">{this.props.children}</div>
				</div>
			</fieldset>
		);
	}
}

FieldsetComponent.propTypes = {
	label: PropTypes.string.isRequired
}


// WEBPACK FOOTER //
// ./src/component/form/fieldset/fieldset-component.js